// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 883 ? "component---src-pages-404-js" : chunkId) + "-" + {"589":"1c9b29cb36b4d818dd77","883":"0827d5a9607abfc67dec"}[chunkId] + ".js";
};